import { module }from 'stereomodularjs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import ResizeObserver from 'resize-observer-polyfill';

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let pageSections = document.querySelectorAll('[data-stereo-anchor-name][id]');

        //Foreach section getAttribute data-stereo-anchor-name
        for (let i = 0; i < pageSections.length; i++) {
            let section = pageSections[i];
            //console.log(section);
            let anchorName = section.getAttribute('data-stereo-anchor-name');
            if(!anchorName){
                //Remove section from array
                pageSections = Array.from(pageSections).filter(item => item !== section);
            }
        }
        
        if(pageSections.length === 0){
            if(document.querySelector('.c-nav-anchors') !== null){
                document.querySelector('.c-nav-anchors').setAttribute('style', 'display:none !important;');
				window.dispatchEvent(new Event('resize'));
            }
            return;
        }

        let sections = gsap.utils.toArray('[data-stereo-anchor-name]');
        this.ItemInViewport = 1;
        this.windowWidth = window.innerWidth;
        this.sectionsCount = pageSections.length;
        this.currentActive = 0;
        this.percentRounded = 0.01;
        this.currentActive = 0;
        this.anchorsMQ = {
            '99999': [10], 
            '1920': [8], 
            '1800': [7], 
            '1440': [6], 
            '960': [1],
            '768': [1],
            '480': [1]
        };

        // foreach page section create a new anchor button with id and name with the markup
        let pageAnchorsItems = "";
        let pageAnchorsItemsMobile = "";
        this.pageAnchorsCount = 0;
        const forEachPromise = new Promise((resolve, reject) => {
            pageSections.forEach((section, index) => {
                this.pageAnchorsCount++;
                let anchor = document.createElement('a');
                let anchorId = section.getAttribute('id');
                let anchorNumber;
                if (this.pageAnchorsCount < 10) {
                    anchorNumber = '0' + this.pageAnchorsCount;
                }else{
                    anchorNumber = this.pageAnchorsCount;
                }
                section.dataset.anchor = anchorId;
                let anchorName = section.getAttribute('data-stereo-anchor-name');
                pageAnchorsItems += `<li class="c-nav-anchors__item">
                        <a class="c-nav-anchors__link" data-scroll-to data-scroll-to-offset="0" href="#${anchorId}">
                            <span class="c-nav-anchors__link-inner">
                                <span class="c-nav-anchors__link-num">${anchorNumber}</span>
                                <span class="c-nav-anchors__link-text">${anchorName}</span>
                            </span>
                        </a>
                        <span class="c-nav-anchors__progress js-nav-anchors__progress"></span>
                    </li>`;
                pageAnchorsItemsMobile += `<li class="c-nav-anchors-mobile__item">
                        <a class="c-nav-anchors-mobile__link" data-scroll-to data-scroll-to-offset="0" href="#${anchorId}">
                            <span class="c-nav-anchors-mobile__link-text">${anchorName}</span>
                        </a>
                    </li>`;
                // Check if it's the last iteration
                if (index === pageSections.length - 1) {
                    document.querySelector('.js-nav-anchors-list').innerHTML = pageAnchorsItems;
                    document.querySelector('.js-nav-anchors-mobile-list').innerHTML = pageAnchorsItemsMobile;
                    resolve();
                }
            });
        });

        // Execute your callback function after the loop finishes
        forEachPromise.then(() => {
            
            this.linkWrapper = document.querySelector('.c-nav-anchors-list');

            if (sections) {
                // value top bottom desktop
                let pageTop = 'top 25%';
                let pageBottom = 'bottom 25%';
                if(window.innerWidth < 960){
                    // value top bottom mobile
                    pageTop = 'top 50%';
                    pageBottom = 'bottom 50%';
                }
                for (let i = 0; i < sections.length; i++) {
                    
                    const section = sections[i];
					let sectionNext = sections[i + 1];
					if(sectionNext === undefined){
						sectionNext = section.parentElement.lastElementChild;
					}
                    ScrollTrigger.create({
                        trigger: section,
						endTrigger: sectionNext,
                        start: pageTop,
                        end: pageBottom,
                        markers: false,
                        onEnter: () => {
                            // desktop
                            if(section.dataset.anchor === undefined){
                                return;
                            }
                            if(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]') === null) return;
                            classAdd(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                            classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-prev');
                            // mobile
                            classAdd(document.querySelector('.c-nav-anchors-mobile__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                        },
                        onLeave: () => {
                            // desktop
                            if(section.dataset.anchor === undefined){
                                return;
                            }
                            if(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]') === null) return;
                            classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                            classAdd(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-prev');
                            // mobile
                            classRemove(document.querySelector('.c-nav-anchors-mobile__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                        },
                        onEnterBack: () => {
                            // desktop
                            if(section.dataset.anchor === undefined){
                                return;
                            }
                            if(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]') === null) return;
                            classAdd(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                            classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-prev');
                            // mobile
                            classAdd(document.querySelector('.c-nav-anchors-mobile__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                        },
                        onLeaveBack: () => {
                            // desktop
                            if(section.dataset.anchor === undefined){
                                return;
                            }
                            if(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]') === null) return;
                            classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                            classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-prev');
                            // mobile
                            classRemove(document.querySelector('.c-nav-anchors-mobile__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                        },
                        onUpdate: (self) => {
                            this.currentActive = i;
                            const progress = self.progress.toFixed(4);
                            const percent = progress * 100;
                            this.percentRounded = Math.round(progress * 100);
                            //console.log(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]'));
                            if(section.dataset.anchor === undefined){
                                return;
                            }
                            if(!document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]')){
                                return;
                            }
                            const progressBarEl = document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').nextElementSibling;
                            document.activeElement.blur();

                            if (progress && progressBarEl) {
                                progressBarEl.style.cssText += `width: ${percent}%;`;
                            }

                            this.update();
                        },
                    });

                    this.update();
                }

                if(this.ItemInViewport > 1){
                    // Set width of link wrapper
                    let linkWrapperWidth = this.sectionsCount / this.ItemInViewport * 100;
                    this.linkWrapper.style.cssText = "width:" + linkWrapperWidth + "%";
                }

                window.addEventListener('resize', () => {
                    this.update();
                });

                this.linkWrapper.addEventListener('wheel', (e) => {
                    this.scroll(e);
                });

                let resizeTimeout;

                const resizeObserver = new ResizeObserver(() => {
                    clearTimeout(resizeTimeout);
                    resizeTimeout = setTimeout(() => {
                        this.update();
                        ScrollTrigger.refresh();
                    }, 302);
                });
                resizeObserver.observe(document.querySelector('body'));
            }

        });

        window.addEventListener('resize', () => {
            this.getNavHeight();
        });
        window.addEventListener('orientationchange', () => {
            this.getNavHeight();
        });
        this.getNavHeight();

        classAdd(document.querySelector('html'), 'has-nav-anchors');
    }

    scroll(event){}

    update(){

        // Set position of link wrapper
        this.windowWidth = window.innerWidth;

        for (let i = 0; i < Object.keys(this.anchorsMQ).length; i++) {
            const key = Object.keys(this.anchorsMQ)[i];
            if (this.windowWidth <= key) {
                this.ItemInViewport = this.anchorsMQ[key];
                break;
            }
        }

        // Set width of link wrapper
        let linkWrapperWidth = this.sectionsCount * 100 / this.ItemInViewport ;
        this.linkWrapper.style.cssText = "width:" + linkWrapperWidth + "%";
        
        if (this.sectionsCount > this.ItemInViewport && this.ItemInViewport > 1) {
            // current offset
            let offset = ((0.01 * this.percentRounded) + this.currentActive - (this.ItemInViewport / 2)) * 100 / this.sectionsCount;
            // max offset
            let offsetCalc = ((this.sectionsCount - this.ItemInViewport) * 100 / this.sectionsCount);
            
            if (offset > offsetCalc) {
                offset = offsetCalc;
            }

            this.linkWrapper.style.cssText += "transform: translateX(-" + offset + "%)";
            
        } else {
            this.linkWrapper.style.cssText = "";
        }
    }

    getNavHeight() {
        // get height of nav anchors
        let navHeight = document.querySelector('.c-nav-anchors').clientHeight;
        // set css variable
        document.documentElement.style.setProperty('--nav-anchor-height', `${navHeight}px`);
    }

	destroy() {
		super.destroy();
        const allScrollTrigger = ScrollTrigger.getAll();
        for (let i = 0; i < allScrollTrigger.length; i++) {
            allScrollTrigger[i].kill(true);
        }
		window.removeEventListener('resize', () => {
			this.update();
		});
		window.removeEventListener('orientationchange', () => {
			this.update();
		});
		window.removeEventListener('resize', () => {
			this.getNavHeight();
		});
		window.removeEventListener('orientationchange', () => {
			this.getNavHeight();
		});
		classRemove(document.querySelector('html'), 'has-nav-anchors');
	}
}